export const wishlistToken = 'wishlist_token';
